export { CampaignCardsUp as default } from './CampaignCardsUp';
